import { render, staticRenderFns } from "./ProfessionGroupsModule.vue?vue&type=template&id=046812c3&scoped=true"
import script from "./ProfessionGroupsModule.vue?vue&type=script&lang=js"
export * from "./ProfessionGroupsModule.vue?vue&type=script&lang=js"
import style0 from "./ProfessionGroupsModule.vue?vue&type=style&index=0&id=046812c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046812c3",
  null
  
)

export default component.exports